import {useSelector} from 'react-redux';
import {RECIPIENT_STATUSES} from '@api/constants';
import {AUTH_USER_ROLE} from '@constants/user';
import {TRANSACTION_PATH} from '@constants/routes';
import {selectAuthUserRole} from '@components/Login/userSlice';
import {selectRecipient, selectSignerUser, selectTransaction} from '../signerUiSlice';

/**
 * Returns the transaction page path when a logged-in user opens the ceremony before their signing turn,
 * so they follow the progress there instead of reaching the documents; null otherwise.
 * @returns {string | null}
 */
export function useFutureSignerRedirectPath(): string | null {
    const authUserRole = useSelector(selectAuthUserRole);
    const recipient = useSelector(selectRecipient);
    const transaction = useSelector(selectTransaction);
    const signerUser = useSelector(selectSignerUser);

    const isFutureSigner = recipient?.status === RECIPIENT_STATUSES.FUTURE_SIGNER;
    const isOwner = !!signerUser?.id && signerUser.id === transaction?.owner_id;

    if (authUserRole !== AUTH_USER_ROLE || !isFutureSigner || isOwner || !transaction?.id) {
        return null;
    }

    return `${TRANSACTION_PATH}/${transaction.id}`;
}
